/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Low_Flat_Deer_ViewInputs */

const fr_low_flat_deer_view = /** @type {(inputs: Low_Flat_Deer_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

/**

* @param {Low_Flat_Deer_ViewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const low_flat_deer_view = /** @type {((inputs?: Low_Flat_Deer_ViewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Low_Flat_Deer_ViewInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_low_flat_deer_view(inputs)
});